import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { AdminCheckConfigComponent } from "../features/admin/forms/check-config/admin-check-config.component";
import { AdminDashboardComponent } from "../features/admin/forms/dashboard/admin-dashboard.component";
import { AdminLayout } from "../features/admin/layouts/admin.layout";
import { AdminCheckConfigResolver } from "../features/admin/resolvers/admin-check-config.resolver";

export class AdminRoutingFactory extends BaseRoutingFactory {

    private readonly coreAdminRoute: Routes = [
        {
            path: '',
            component: AdminLayout,
            children: [
                {
                    path: '',
                    redirectTo: 'dashboard',
                    pathMatch: 'full',
                },
                {
                    path: 'dashboard',
                    component: AdminDashboardComponent
                },
                {
                    path: 'check-config',
                    component: AdminCheckConfigComponent,
                    resolve: {
                        checkConfig: AdminCheckConfigResolver
                    }
                }
            ]
        }
    ];
    

    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }
    
    protected get coreRoute(): Routes {
        return this.coreAdminRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute![0].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        }
        else {
            coreRoute![0].children!.push(route);
        }
    }
    
}